import * as React from 'react';
import RoutePrivate from '../router/RoutePrivate';

import ClientsPage from '../../components/clients/ClientsPage';
// import AddClientPage from './AddClientPage';
import CreateClientPage from './CreateClient';
import EditClientPage from './EditClientPage';

export default function getRoutes(isLoggedIn: boolean) {
    return [
        <RoutePrivate key="add-client" path="/clients/create" component={CreateClientPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="edit-client" path="/clients/:clientNumber/edit" component={EditClientPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="client-detail" path="/clients/:clientNumber" component={ClientsPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="clients" path="/clients" component={ClientsPage} isLoggedIn={isLoggedIn} />,
    ];
}



// WEBPACK FOOTER //
// ./src/components/clients/Client.Routes.tsx